/**
 * COGNODATA, Cliente de caché de datos de servidor
 * Copyright (c) 2025 Cognoware Cia. Ltda.
 * Todos los derechos reservados.
 *
 * Este archivo forma parte del COGNODATA de
 * Cognoware Cia. Ltda, desarrollado conforme a los requerimientos y
 * normativas establecidos.
 */
import {QueryClient} from 'react-query'
import {STALE_TIME} from './service'

/**
 * Función `createQueryClient`:
 *
 * Crea el cliente de caché de datos de servidor. Es el **único** sitio donde se configuran la frescura,
 * los reintentos y la recarga automática, y el archivo que habría que tocar al subir la versión de la
 * librería de consultas.
 *
 * Los nombres son los de react-query 3: la caducidad de la caché se llama `cacheTime`, no `gcTime`.
 * Hoy el repositorio no tiene ninguna consulta, así que estas opciones fijan el punto de partida de las
 * que se escriban, sin alterar lo que ya funciona.
 *
 * @return (QueryClient): cliente listo para el proveedor de la aplicación o para una prueba.
 */
export const createQueryClient = (): QueryClient => new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: STALE_TIME,
            cacheTime: STALE_TIME,
            retry: 0,
            refetchOnWindowFocus: false
        }
    }
})
